<template>
    <div>
        <v-dialog v-model="mostrar" max-width="375" persistent>
            <v-card :loading="loading">
                <v-card-title class="headline">Cambiar contraseña:</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field 
                                    v-model="actual" 
                                    name="SG-NU-actual" 
                                    label="Contraseña actual:"
                                    type="password"
                                    :error-messages="errors.actual"
                                    @input="validarActual()"
                                    @blur="validarActual()"
                                    >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field 
                                    v-model="nueva1" 
                                    name="SG-NU-nueva1" 
                                    label="Contraseña nueva:"
                                    type="password"
                                    :error-messages="errors.nueva1"
                                    @input="validarNueva1()"
                                    @blur="validarNueva1()"
                                    >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field 
                                    v-model="nueva2" 
                                    name="SG-NU-nueva2" 
                                    label="Repita nueva:"
                                    type="password"
                                    :error-messages="errors.nueva2"
                                    @input="validarNueva2()"
                                    @blur="validarNueva2()"
                                    >
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue-grey darken-1" outlined text @click="$emit('cancelar')">Cancelar</v-btn>
                    <v-btn color="blue-grey darken-1" dark @click="cambiarPassword()">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters} from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
    props:['mostrar'],
    mixins: [validationMixin],
    data: () => ({
        loading: false,
        actual: null,
        nueva1: null,
        nueva2: null,
        errors:{
            actual: [],
            nueva1: [],
            nueva2: [],
        },
    }),
    validations: {
        actual: { required, minLength: minLength(5) },
        nueva1: { required, minLength: minLength(5) },
        nueva2: { required, minLength: minLength(5) },
    },
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken",
            "userId"
        ])
    },
    methods:{
        validarActual(){
            this.$v.actual.$touch();
            const errors = []
            if (this.$v.actual.$dirty){
                !this.$v.actual.required && errors.push('Campo requerido.')
                !this.$v.actual.minLength && errors.push('Mínimo 5 caracteres.')
            }
            this.errors.actual = errors;
        },
        validarNueva1(){
            this.$v.nueva1.$touch();
            const errors = []
            if (this.$v.nueva1.$dirty){
                !this.$v.nueva1.required && errors.push('Campo requerido.')
                !this.$v.nueva1.minLength && errors.push('Mínimo 5 caracteres.')
            }
            this.errors.nueva1 = errors;
        },
        validarNueva2(){
            this.$v.nueva2.$touch();
            const errors = []
            if (this.$v.nueva2.$dirty){
                !this.$v.nueva2.required && errors.push('Campo requerido.')
                !this.$v.nueva2.minLength && errors.push('Mínimo 5 caracteres.')
            }
            this.errors.nueva2 = errors;
        },
        cambiarPassword(){
            this.$v.$touch();
            this.validarActual();
            this.validarNueva1();
            this.validarNueva2();
            if (!this.$v.$invalid) {
                if( this.nueva1 != this.nueva2 )
                    this.errors.nueva2 = ['La contraseña nueva no coincide'];
                else{
                    this.loading = true;
                    axios.put(this.httpURL+'/usuario/cambiarPassword/'+this.userId,
                        {actual: this.actual, nueva:this.nueva1},
                        {headers:{token:this.sessionToken}})
                    .then(res => {
                        // console.log(res.data);
                        if( res.data.ok ){
                            this.$notify({ group: 'gral_notif', type:"success", duration:1500, speed: 500, text: res.data.mensaje });
                            this.$emit('cancelar');
                        }else{
                            if( res.data.actual)
                                this.errors.actual = [res.data.mensaje];
                            else
                                this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                        }
                            this.loading = false;
                    })
                    .catch(error => {
                        // console.log('Error: '+error);
                        this.loading = false;
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                    });
                }
            }
        }
    }
}
</script>
